import React from "react"
import { Row, Col, Form } from "react-bootstrap"
import { getIn } from "formik"
import NumberFormat from "react-number-format"
import FormLabel from "./formLabel"

function FormTimeTextbox(props) {
  const { textDesc, form, field } = props

  const errorsMsg = getIn(form.errors, field.name)
  // const touched = getIn(form.touched, field.name)

  const inputErrorClassName = (touched, errors, inputName) => {
    return errors[inputName] && touched[inputName] ? "is-invalid" : null
  }

  const inputErrorMessage = (touched, errors, inputName) => {
    return errors[inputName] && touched[inputName] ? (
      <span className="InputError">{errorsMsg}</span>
    ) : null
  }

  const timeFormat = val => {
    let hour = limit(val.substring(0, 2), "23")
    let minute = limit(val.substring(2, 4), "59")

    return hour + (minute.length ? ":" + minute : "")
  }

  const limit = (val, max) => {
    if (val.length === 2) {
      //this can happen when user paste number
      if (val > max) {
        val = max
      }
    }
    return val
  }

  return (
    <div className="marginBottom19px">
      <FormLabel text={textDesc} />
      <div className="marginTop10px">
        <NumberFormat
          name={field.name}
          placeholder="HH:mm"
          className={
            "d-block inputbox " +
            inputErrorClassName(form.touched, form.errors, field.name)
          }
          type="text"
          format={timeFormat}
          maxLength={5}
          autoComplete="new-password"
          value={field.value || ""}
          onChange={form.handleChange}
          onBlur={form.handleBlur}
        />
        {/* {errors && touched && <span className="InputError">{errors}</span>} */}
        {/* <span className="InputError">{errors}</span> */}
        {inputErrorMessage(form.touched, form.errors, field.name)}
      </div>
    </div>
  )
}
export default FormTimeTextbox
